import { combineReducers } from "redux";
import { getStatusReducer, getErrorReducer, getIndexesReducer } from "../utils/reducer-generators";
import { getSuccessActionType } from "../utils/get-action-types";
import { FETCH_OFFICES, UPDATE_OFFICE_DETAILS } from "../constants/offices";
import { Office } from "../types";
import { Action } from "../models/offices";

function data(state: Office[] = [], action: Action): Office[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_OFFICES):
      return action.payload;
    case getSuccessActionType(UPDATE_OFFICE_DETAILS): {
      const { officeId } = action.data;
      const indexU = state.findIndex((i) => i.id === officeId);
      const updatedOffice = action.payload as unknown as Office;
      state[indexU].ignoreHoliday = updatedOffice.ignoreHoliday;
      return [...state];
    }
    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_OFFICES]),
  error: getErrorReducer([FETCH_OFFICES]),
  indexes: getIndexesReducer(FETCH_OFFICES),
  data,
});
